import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"

import RegistrationContainer from "@/screens/CompanySettings/Registration/containers/RegistrationContainer"

export const Route: AnyRoute = createFileRoute("/app/companies/$companyId/edit/_layout/registration")({
  component: () => <RegistrationContainer />,
})
